import withBaseDrawer from 'components/common/Drawers/withBaseDrawer';

export default withBaseDrawer;
